import { render, staticRenderFns } from "./favoriteCard.vue?vue&type=template&id=447d3e41&"
import script from "./favoriteCard.vue?vue&type=script&lang=js&"
export * from "./favoriteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports